import { useEffect, useState } from "react"
import { Paper, Typography } from "@mui/material"
import { BLOCK_CONTAINER_ICON } from "./Helper"

/**
 * BlockContainer Component
 * Component to display total cost/saving on Optimization pages
 * @param {*} props 
 * @returns 
 */
export const BlockContainer = (props) => {
  const [order, setOrder] = useState(props['order'] ?? 1)
  const [displayValue, setDisplayValue] = useState(props['displayValue'] ?? 0)
  const [displayLabel, setDisplayLabel] = useState(props['displayLabel'] ?? 0)
  const [displayIcon, setDisplayIcon] = useState(props['displayIcon'] ?? BLOCK_CONTAINER_ICON.SAVING)
  const [bgColor, setBGColor] = useState(props['displayBGColor'] ?? '')
  const [textLabelColor, setTextLabelColor] = useState(props['displayTextLabelColor'] ?? '')
  const [textValueColor, setTextValueColor] = useState(props['displayTextValueColor'] ?? '#404040')
  const [unitValue, setUnitValue] = useState(props['unitValue'] ?? '')
  const [showActionLink, setShowActionLink] = useState('HIDE')
  const [actionHandler, setActionHandler] = useState(props['actionHandler'] ?? null)

  // const { type } = useCurrentInstanceType()
  const onActionTaken = () => {
    props['actionHandler']()
  }

  useEffect(() => {
    setUnitValue(props['unitValue'] ?? '')
  }, [props['unitValue']])

  useEffect(() => {
    setDisplayValue(props['displayValue'] ?? 0)
    setDisplayLabel(props['displayLabel'] ?? 0)
    setBGColor(props['displayBGColor'] ?? 0)
    setDisplayIcon(props.displayIcon ?? BLOCK_CONTAINER_ICON.SAVING)
  }, [props.displayValue, props.displayLabel, props.displayBGColor, props.displayIcon])

  useEffect(() => {
    setShowActionLink(props['showActionLink'])
  }, [props['showActionLink']])

  return (
    <Paper elevation={12} className={`block-container order${order}`}>
      <div><img src={`/${displayIcon}${order}-icon.svg`} alt={`${'s.title'}`} /></div>
      <div>
        <Typography variant="p">{displayLabel}</Typography>
        <Typography variant='h4' color={'#012A4A'} >{unitValue}{displayValue}</Typography>
        {showActionLink === 'SHOW' && <div>
          <Typography component={'a'} variant="caption"
            color={'#20a7db'}
            onClick={() => onActionTaken()}
            style={{
              borderBottom: '1px dashed',
              cursor: 'pointer'
            }}>
            View details
          </Typography>
        </div>
        }
      </div>
    </Paper>
  )

  // <Paper style={{
  //   padding: '7px',
  //   // display: 'flex',
  //   // justifyContent: 'center',
  //   // alignItems: 'center',
  //   backgroundColor: bgColor,
  //   width: '100%',
  //   height: '100%'
  // }} >
  //   <Grid container >
  //     <Grid item xs={12}>
  //       <Typography variant="h6" style={{
  //         // fontSize: '14px',
  //         // marginRight: '10px',
  //         fontStyle: 'italic',
  //         color: textLabelColor
  //       }}>
  //         {unitValue}{displayValue}
  //       </Typography>
  //     </Grid>

  //     <Grid item xs={12}>
  //       <Typography variant="caption" color={textValueColor}>
  //         {/* <span style={{
  //             // fontSize: '13px',
  //             color: textValueColor */}
  //         {/* }}>{displayLabel}</span> */}
  //         {displayLabel}
  //       </Typography>
  //       {showActionLink === 'SHOW' && <div>
  //         <Typography component={'a'} variant="caption"
  //           color={'#20a7db'}
  //           onClick={() => onActionTaken()}
  //           style={{
  //             borderBottom: '1px dashed',
  //             cursor: 'pointer'
  //           }}>
  //           View details
  //         </Typography>
  //       </div>
  //       }
  //     </Grid>
  //   </Grid>
  // </Paper>
}